import React from "react";

const ASP_FileSystem = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP FileSystem</h1>
      <p>This is the ASP FileSystem page content.</p>
    </div>
  );
};

export default ASP_FileSystem;
